<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="ORIM-Book-Title" id="_idParaDest-1"><span class="CharOverride-1"><a id="_idTextAnchor000"></a>The Time Traders</span></p>
<p class="ORIM-Book-Title1"><span class="CharOverride-1">Book One of the Time Traders Series</span></p>
<p class="ORIM-Author-Name"><span class="CharOverride-2">Andre Norton</span></p>
<p class="ORIM-Author-Name"><img alt="logo2" src="image/logo2.jpg"/><a id="_idTextAnchor004"></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// The_Time_Traders-1.vue?672b4c1b